import { render, staticRenderFns } from "./MenuLocal.vue?vue&type=template&id=a668c116&scoped=true&"
import script from "./MenuLocal.vue?vue&type=script&lang=js&"
export * from "./MenuLocal.vue?vue&type=script&lang=js&"
import style0 from "./MenuLocal.vue?vue&type=style&index=0&id=a668c116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a668c116",
  null
  
)

export default component.exports